import * as React from 'react'

import AttachSvg from '#/assets/svg/attach.svg?react'
import PlusSvg from '#/assets/svg/plus.svg?react'
import { ERROR_REPORT, getModalById, PlateTemplate } from '#/features/modals'
import { c } from '#/shared'
import { CommonButton } from '#/shared/ui/button'
import { CommonTextArea } from '#/shared/ui/common-textarea'

import { useErrorReport } from '../model/use-error-report'

import styles from './error-report.module.scss'

export const ErrorReportPlate = () => {
	const modal = getModalById(ERROR_REPORT)

	const { error, isSend, setErrorMessage, handleFileChange, file, setFile, sendError } = useErrorReport()

	return (
		<PlateTemplate id={ERROR_REPORT} variant='secondary' hasTemplate={false}>
			{isSend ? (
				<div className={c(styles.container, styles.container_sended)}>
					<p className={styles.text_accent}>Спасибо!</p>
					<p className={styles.text}>Ваше сообщение направлено нашим специалистам. Ответ придет на почту, указанную при регистрации</p>
				</div>
			) : (
				<div className={styles.container} onClick={(e) => e.stopPropagation()}>
					<p className={styles.text_heading}>Сообщить об ошибке</p>
					<CommonTextArea
						showError={false}
						error={error ? { message: 'Поле не должно быть пустым.', type: 'required' } : undefined}
						rows={4}
						className={styles.textarea}
						placeholder='Опишите детально возникшую проблему'
						onChange={(evt) => setErrorMessage(evt.target.value)}
						buttomSlot={
							<>
								<button className={styles.textarea__button}>
									<input
										onChange={handleFileChange}
										type='file'
										accept='.jpg,.jpeg,.png'
										className={styles.fileInputHidden}
										id='file-input'
									/>
									<label htmlFor='file-input' className={styles.fileInputLabel}>
										<AttachSvg width={25} height={25} color={error ? '#ff2372' : '#868686'} />
									</label>
								</button>
							</>
						}
					/>
					{file && (
						<div className={styles.textarea__file}>
							<div className={styles.textarea__fileInfo}>
								<AttachSvg width={18} height={18} />
								<div className={styles.textarea__fileMeta}>
									<span className={styles.textarea__fileName}>{file.name}</span>
									<span className={styles.textarea__fileSize}>{(file.size / 1024).toFixed(1)} KB</span>
								</div>
							</div>

							<button className={styles.container__close} onClick={() => setFile(undefined)}>
								<PlusSvg width={18} height={18} />
							</button>
						</div>
					)}
					<div className={styles.container__buttons}>
						<CommonButton variant='gray' onClick={() => modal.setState(false)}>
							Отмена
						</CommonButton>
						<CommonButton variant='primary' onClick={sendError}>
							Отправить
						</CommonButton>
					</div>
				</div>
			)}
		</PlateTemplate>
	)
}
